import { render, staticRenderFns } from "./ScrollingDocument.vue?vue&type=template&id=332e8a99&scoped=true&"
import script from "./ScrollingDocument.vue?vue&type=script&lang=js&"
export * from "./ScrollingDocument.vue?vue&type=script&lang=js&"
import style0 from "./ScrollingDocument.vue?vue&type=style&index=0&id=332e8a99&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332e8a99",
  null
  
)

export default component.exports